<app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplate" [modulo]="DAT_TITULOS.modulo"
                  [tituloCard]="titulo" [titulo]="DAT_TITULOS.titulo">
</app-lfsa-card-v2>
<ng-template #innTemplateButton>
</ng-template>
<ng-template #enviarTemplate>
  <br>
  <section class="section">
    <div class="row">
      <div *ngFor="let item of lista" class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5>{{ item.cliente.cliNombre}}</h5>
          </div>
          <div class="card-body">
            <app-lfsa-gh-gauge [colorAmarillo]="item.vmiAmortamarillo"
                               [colorRojo]="item.vmiAmortrojo" [colorVerde]="item.vmiAmortverde"
                               [data]="$any(item).round" [title]="item.articulo.artDescripcion" [unidadText]="'Kilogramos'"
                               [unidad]="'Kg'">
            </app-lfsa-gh-gauge>
          </div>
        </div>
        <br>
      </div>
    </div>
  </section>
</ng-template>
